/**
 * @name vg dropdown
 * @copyright by vegas s.
 * @date: 03.04.2020
 * @last-update: 08.10.2020
 * @version  1.5
 *
 */
window.vgDropdown = {
	container: '.vg-dropdown',
	content: '.vg-dropdown-content',
	setting: null,
	defaults: {
		placement: 'left',
		hard_placement: false,
		offset: 0
	},

	init: function ($self) {
		let data = $self.data();

		this.setting = $.extend(this.setting, this.defaults, data);
		this.setParams($self);
		this.setting = {};
	},
	setParams: function ($self) {
		let $container = $self.closest(this.container),
			$drop = $container.find(this.content);

		$self.attr('area-expanded', false);

		if ('offset' in this.setting) {
			$drop.css(this.setting.placement, parseInt(this.setting.offset))
		}

		if ('width' in this.setting) {
			$drop.css('width', parseInt(this.setting.width))
		}

		this.setPlacement($drop);
	},
	setPlacement: function ($drop) {
		$drop.addClass(this.setting.placement);

		if (!this.setting.hard_placement) {
			let body_width = $('body').width(),
				drop_width = $drop.width(),
				offset = {
					left: $drop.offset().left,
					right: body_width - ($drop.offset().left + drop_width)
				};

			if (body_width < 700) {
				$drop.css('left', 0);
				$drop.css({
					'width': (body_width - 30),
					'left': -($drop.offset().left) + 15,
					'right': 'initial'
				});
			} else {
				if ($drop.hasClass('left')) {
					if (offset.right < drop_width / 2) {
						$drop.css({
							'left': 'initial',
							'right': this.setting.offset
						})
					} else {
						$drop.css({
							'left': this.setting.offset,
							'right': 'initial'
						})
					}
				} else if ($drop.hasClass('right')) {
					if (offset.left < drop_width / 2) {
						$drop.css({
							'left': this.setting.offset,
							'right': 'initial'
						})
					} else {
						$drop.css({
							'left': 'initial',
							'right': this.setting.offset
						})
					}
				}
			}
		}
	},
	open: function ($self) {
		let $container = $self.closest(this.container),
			$drop = $container.find(this.content),
			$drops = $('body').find(this.content);

		if ($drop.hasClass('show')) {
			this.close(false, $drop, $self)
		} else {
			if ($drops.length) {
				$drops.each(function () {
					vgDropdown.close(false, $(this));
				});
			}

			$drop.addClass('show');
			$self.attr('area-expanded', true);
		}
	},
	close: function (e, $drop, $self = false) {
		if (!$self && $drop) {
			$self = $drop.closest(this.container).find('[data-toggle]');
		}

		if ($drop && $drop.length) {
			return closer($drop, $self);
		} else {
			let $container = $(this.container),
				$toggle = $container.find('[data-toggle]');
			if ($container.has(e.target).length === 0) {
				return closer($container.find(this.content), $toggle);
			}
		}

		function closer(drop, toggle) {
			drop.removeClass('show');
			toggle.attr('area-expanded', false);
			return false;
		}
	},
};

$(document).ready(function () {
	$('[data-toggle=vg-dropdown]').each(function () {
		vgDropdown.init($(this));
	});
});

$(document).on('click', '[data-toggle=vg-dropdown]', function () {
	vgDropdown.open($(this));

	return false;
});

$(document).on('click', '[data-dismiss=vg-dropdown]', function (e) {
	vgDropdown.close(e, $(this).closest(vgDropdown.container).find(vgDropdown.content));

	return false;
});

$(document).mouseup(function (e) {
	vgDropdown.close(e);

	return true;
});

$(window).on('resize', function () {
	$('.vg-dropdown-content').each(function () {
		vgDropdown.setPlacement($(this));
	});

	return true;
});
